<template lang="pug">
section.lista-monitoramento-socioambiental
    BaseHeader(
        titulo='Monitoramento Socioambiental',
        icon='el-icon-circle-plus-outline',
        btnTexto='Novo Monitoramento',
        :exibeBotao='true',
        @btnHeaderClicado='clickBotaoHeader'
    )

    .view-container-base-header
        FiltrarMonitoramentoSocioambiental(
            :categoria='categoriaSelecionada',
            @atualizar-filtro-avancado='atualizarFiltroAvancado',
            @remover-categoria-selecionada='removerCategoriaSelecionada'
        )
        BlocoAlertaMonitoramentoSocioambiental.mb-3
        BlocoCategoriaMonitoramentoSocioambiental.mb-3(
            :remover-categoria='removerCategoria',
            @atualizar-filtro-avancado='atualizarFiltroAvancado'
        )
        BlocoTotalizadorMonitoramentoSocioambiental.mb-3(
            :filtros='filtros',
            ref='blocoTotalizador'
        )
        ListaAreaMonitoradaSocioambiental.mb-3(
            :filtros='filtros',
            @buscarTotalizadores='buscarTotalizadores'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoCategoriaMonitoramentoSocioambiental from '@/components/monitoramento/BlocoCategoriaMonitoramentoSocioambiental';
import BlocoTotalizadorMonitoramentoSocioambiental from '@/components/monitoramento/BlocoTotalizadorMonitoramentoSocioambiental';
import FiltrarMonitoramentoSocioambiental from '@/components/monitoramento/FiltrarMonitoramentoSocioambiental';
import BlocoAlertaMonitoramentoSocioambiental from '@/components/monitoramento/BlocoAlertaMonitoramentoSocioambiental';
import ListaAreaMonitoradaSocioambiental from '@/components/monitoramento/ListaAreaMonitoradaSocioambiental';

export default {
    name: 'ListaMonitoramentoSocioAmbiental',
    components: {
        BaseHeader,
        BlocoCategoriaMonitoramentoSocioambiental,
        BlocoTotalizadorMonitoramentoSocioambiental,
        BlocoAlertaMonitoramentoSocioambiental,
        FiltrarMonitoramentoSocioambiental,
        ListaAreaMonitoradaSocioambiental
    },
    data() {
        return {
            filtros: {
                idBiomas: [],
                idCategorias: [],
                idRepresentantes: [],
                idTerritorios: []
            },
            listaAreaMonitoradaSocioambiental: [],
            categoriaSelecionada: null,
            removerCategoria: {
                remover: false,
                id: null
            }
        };
    },
    methods: {
        clickBotaoHeader() {
            this.$router.push({ name: 'CadastrarMonitoramentoSocioAmbiental' });
        },
        removerCategoriaSelecionada(idEnviado) {
            this.removerCategoria = {
                remover: true,
                id: idEnviado
            };
        },
        atualizarFiltroAvancado(filtros, categoria) {
            this.filtros = {
                ...this.filtros,
                ...filtros
            };

            if (categoria) {
                this.categoriaSelecionada = {
                    id: categoria.id,
                    nome: categoria.nome,
                    classe: categoria.classe,
                    codigo: categoria.codigo
                };
            } else {
                this.categoriaSelecionada = null;
            }
        },

        buscarTotalizadores() {
            this.$refs.blocoTotalizador.buscarTotalizadores();
        }
    }
};
</script>
<style lang="scss" scoped>
.lista-monitoramento-socioambiental {
    height: 100%;
    width: 100%;
}
</style>
